import { useRef, useMemo } from 'react';
import { VideoElementRefs } from '../types';

export const useVideoRefs = (): VideoElementRefs => {
  // Create refs at top level
  const localVideoRef = useRef<HTMLVideoElement>(null);
  const remoteVideoRefs = useRef<{[key: string]: HTMLVideoElement | null}>({});

  // Initialize remote.current immediately
  if (!remoteVideoRefs.current) {
    remoteVideoRefs.current = {};
  }

  // Memoize the videoRefs object structure
  const videoRefs: VideoElementRefs = useMemo(() => {
    console.log('useVideoRefs: Creating videoRefs object structure');
    return {
      local: localVideoRef,
      remote: remoteVideoRefs,
    };
  }, []);

  return videoRefs;
};
